export const SNIPPET_SIZE = 600;
export const SNIPPET_DISPLAY_SIZE = SNIPPET_SIZE / 2;